import * as CodeMirror from 'codemirror';
import { repeat } from "lodash-es";
import { highlightRect } from "../../../../lib/utils/browser";
import { getTitleWithParentheses } from "../../../../lib/utils/string";
import { toRect } from "../../../../lib/utils/styling";
import * as style from "./style.module.css";
import startCapture, { capturing, hoverHighlightRect } from './captureComp';
import { splitCompPath } from "../../../../lib/utils";
import captureIcon from "../../../../lib/assets/captureIcon.svg";
function onCapture(e, data, {
  cm,
  designer
}) {
  var _designer$uc;
  if (!data) return;
  const renderers = designer.scopeStack.map(scope => scope.renderer);
  renderers.push(designer === null || designer === void 0 || (_designer$uc = designer.uc) === null || _designer$uc === void 0 ? void 0 : _designer$uc.renderer);
  const currentRenderer = data.scopedStack[0];
  const {
    path
  } = data;
  function getName(path) {
    var _currentRenderer$getR;
    return designer.uc.getLayoutName(currentRenderer === null || currentRenderer === void 0 || (_currentRenderer$getR = currentRenderer.getRefByPath(path)) === null || _currentRenderer$getR === void 0 || (_currentRenderer$getR = _currentRenderer$getR.$vnode.data) === null || _currentRenderer$getR === void 0 ? void 0 : _currentRenderer$getR['uc:layout']);
  }
  function getRelativeCompPath(comp) {
    var _comp$$vnode$data, _comp$$vnode$data2;
    const index = renderers.indexOf(comp === null || comp === void 0 || (_comp$$vnode$data = comp.$vnode.data) === null || _comp$$vnode$data === void 0 ? void 0 : _comp$$vnode$data['uc:renderer']);
    if (index === -1) return '捕获失败, 请手写选择器表达式';
    const ref = comp === null || comp === void 0 || (_comp$$vnode$data2 = comp.$vnode.data) === null || _comp$$vnode$data2 === void 0 ? void 0 : _comp$$vnode$data2.ref;
    const prefix = repeat('^^ ', index);
    return prefix + (ref ? `#${ref}` : '');
  }
  // 打开组件选择菜单
  function getCompParentTreeContextMenu() {
    const pathParts = splitCompPath(path).map(x => x.compPath);
    if (pathParts[0]) pathParts.unshift('');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const h = designer.$createElement;
    const items = pathParts.reverse().map(compPath => {
      const compInstance = currentRenderer === null || currentRenderer === void 0 ? void 0 : currentRenderer.getRefByPath(compPath);
      return {
        title: h("div", {
          "style": "display: flex; max-height: 1.3em",
          "on": {
            "click": () => {
              // 把路径转换成组件语法
              cm.setValue(getRelativeCompPath(compInstance));
              hoverHighlightRect(compInstance, false);
            },
            "mouseenter": () => {
              hoverHighlightRect(compInstance);
            },
            "mouseleave": () => {
              hoverHighlightRect(compInstance, false);
            }
          }
        }, [" ", getName(compPath), " "])
      };
    });
    return {
      title: '选择组件',
      items
    };
  }
  const menu = getCompParentTreeContextMenu();
  if (menu.items.length) {
    designer.openContextMenu(e, [menu]);
  } else {
    cm.setValue(getRelativeCompPath(currentRenderer === null || currentRenderer === void 0 ? void 0 : currentRenderer.getRefByPath(data.path)));
  }
}
export async function compSelectorHint(cm, opts) {
  const pos = cm.getCursor();
  const token = cm.getTokenAt(CodeMirror.Pos(pos.line, pos.ch));
  const state = token.state;
  const tokenStart = CodeMirror.Pos(pos.line, token.start);
  const tokenEnd = CodeMirror.Pos(pos.line, token.end);
  const querySelector = () => {
    var _designer$renderer;
    const designer = opts.getDesigner();
    if (!designer) return null;
    const partialExpr = cm.getRange(CodeMirror.Pos(0, 0), tokenStart);
    return (_designer$renderer = designer.renderer) === null || _designer$renderer === void 0 ? void 0 : _designer$renderer.ucQuerySelector(partialExpr, designer.compPath);
  };
  const firstPass = () => {
    switch (state.lastInside) {
      case 'none':
        return {
          from: pos,
          to: pos,
          list: [{
            text: '',
            displayText: '从页面中选中组件',
            render: (elt, data, item) => {
              elt.className += ` ${style.compSelectorHintItem} ${style.captureFromPage} `;
              elt.innerHTML = `<span style="white-space:nowrap;">
                <img src="${captureIcon}" class="capture_icon" />
                <span> ${capturing ? '捕获中...' : item.displayText} </span>
                </span > `;
              elt.addEventListener('click', () => {
                const designer = opts.getDesigner();
                !capturing && startCapture({
                  onCapture: (e, cData) => onCapture(e, cData, {
                    cm,
                    designer
                  }),
                  designer
                });
              }, false);
            }
          }, {
            text: '^',
            displayText: '外层的..组件'
          }, {
            text: '#',
            displayText: '（当前区域）指定ID的组件'
          }]
        };
      case 'parent':
        {
          const curr = querySelector();
          if (!curr) return null;
          let factory = curr.renderer.ucFactoryLUT.byCompPath[curr.compPath];
          let renderer = curr.renderer;
          const list = [];
          const visitedCounter = {};
          while (factory && renderer) {
            var _factory$compMeta, _renderer;
            const compType = factory.comp.type;
            const repTimes = (visitedCounter[compType] || 0) + 1; // 多层嵌套了一个组件可能需要考虑
            list.push({
              text: repeat(`^${compType} `, repTimes).trim(),
              displayText: getTitleWithParentheses(compType, (_factory$compMeta = factory.compMeta) === null || _factory$compMeta === void 0 ? void 0 : _factory$compMeta.name),
              renderer,
              compPath: factory.compPath,
              isScopeRoot: factory.isScopeRoot
            });
            visitedCounter[compType] = repTimes;
            if (factory.isScopeRoot) renderer = (_renderer = renderer) === null || _renderer === void 0 ? void 0 : _renderer.ucParentRenderer;
            factory = factory.parent;
          }
          list.shift(); // 删除当前组件
          return {
            from: tokenStart,
            to: tokenEnd,
            list
          };
        }
      case 'componentId':
        {
          const curr = querySelector();
          if (!curr) return null;
          const renderer = curr.renderer;
          const factoryLUT = renderer === null || renderer === void 0 ? void 0 : renderer.ucFactoryLUT.byId;
          if (!factoryLUT) return null;
          return {
            from: tokenStart,
            to: tokenEnd,
            list: Object.keys(factoryLUT).map(id => {
              var _factory$compMeta2;
              const factory = factoryLUT[id];
              const compTypeName = ((_factory$compMeta2 = factory.compMeta) === null || _factory$compMeta2 === void 0 ? void 0 : _factory$compMeta2.name) || factory.comp.type;
              return {
                text: `#${id} `,
                displayText: getTitleWithParentheses(`#${id} `, compTypeName),
                compPath: factory.compPath,
                renderer: renderer,
                isScopeRoot: factory.isScopeRoot
              };
            })
          };
        }
    }
  };
  const answer = firstPass();
  if (!answer) return null;
  const matchingText = token.string.slice(0, pos.ch - token.start).trim();
  if (matchingText) answer.list = answer.list.filter(x => x.text.startsWith(matchingText));
  const highlightItem = item => {
    var _item$renderer;
    if (typeof item.compPath !== 'string') return;
    const compInstance = (_item$renderer = item.renderer) === null || _item$renderer === void 0 ? void 0 : _item$renderer.getRefByPath(item.compPath);
    if (compInstance) highlightRect(toRect(compInstance));
  };
  CodeMirror.on(answer, 'select', highlightItem);
  CodeMirror.on(answer, 'pick', () => {
    setTimeout(() => {
      cm.showHint(); // 梅开二度
    }, 150);
  });
  answer.list.forEach(item => {
    if (!item.render) {
      // eslint-disable-next-line no-param-reassign
      item.render = function (elt, _, item) {
        var _item$displayText;
        elt.className += ` ${style.compSelectorHintItem} `;
        if (item.isScopeRoot) elt.className += ` ${style.isScopeRoot} `;
        elt.textContent = (_item$displayText = item.displayText) !== null && _item$displayText !== void 0 ? _item$displayText : item.text;
        elt.addEventListener('mouseenter', () => highlightItem(item), false);
      };
    }
  });
  return answer;
}
//# sourceMappingURL=compSelectorHint.js.map
